import { render } from "./BaoCaoThongKeTinhHinhSDVacxinDaGoi.vue?vue&type=template&id=e7729a36&ts=true"
import script from "./BaoCaoThongKeTinhHinhSDVacxinDaGoi.vue?vue&type=script&lang=ts"
export * from "./BaoCaoThongKeTinhHinhSDVacxinDaGoi.vue?vue&type=script&lang=ts"

import "./BaoCaoThongKeTinhHinhSDVacxinDaGoi.vue?vue&type=style&index=0&id=e7729a36&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/CDC/BaoCao/CDC_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__